import Container from "@mui/material/Container";
import React from "react";
import { useLocation } from "react-router-dom";

import NavBar from "./NavBar";
import IncomingTeacherInvitations from "../features/students/components/IncomingTeacherInvitations";
import { useVisualViewportHeight } from "../hooks/useVisualViewportHeight";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  const practice = pathname.startsWith("/practice/");
  const focused =
    practice ||
    pathname.startsWith("/dictation/") ||
    pathname === "/dictionary/adaptive";
  const learning =
    focused ||
    pathname === "/dictionary" ||
    pathname === "/dictionary/words" ||
    pathname === "/dictation";
  useVisualViewportHeight();
  return (
    <>
      <NavBar />
      <Container
        maxWidth="lg"
        data-learning-viewport={learning || undefined}
        sx={{
          height: learning
            ? {
                xs: `calc(var(--app-viewport-height, 100dvh) - 56px - ${focused ? "0px" : "56px - env(safe-area-inset-bottom)"})`,
                sm: `calc(var(--app-viewport-height, 100dvh) - 64px - ${focused ? "0px" : "56px - env(safe-area-inset-bottom)"})`,
                md: "calc(var(--app-viewport-height, 100dvh) - 64px)",
              }
            : undefined,
          minHeight: 0,
          overflow: learning ? "hidden" : undefined,
          pt: learning ? { xs: 1, sm: 1.5 } : 4,
          pb: learning
            ? focused && !practice
              ? "max(8px, env(safe-area-inset-bottom))"
              : 1
            : { xs: 12, md: 5 },
          "body[data-keyboard-open='true'] &": learning
            ? {
                height: {
                  xs: "calc(var(--app-viewport-height, 100dvh) - 56px)",
                  sm: "calc(var(--app-viewport-height, 100dvh) - 64px)",
                },
              }
            : undefined,
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <IncomingTeacherInvitations showBanner={!learning} />
        {children}
      </Container>
    </>
  );
};
export default Layout;
